import { Component, EventEmitter, Inject, Output } from '@angular/core';

import { L10N_LOCALE, L10nLocale } from 'angular-l10n';

import { environment } from '../../../../../../environments/environment';
import { LocalizableComponent } from '../../../../localization/localizable.component';
import { WhatsNewService } from '../../../../services/whats-new/whats-new.service';

@Component({
  selector: 'broker-whats-new-dialog',
  templateUrl: './whats-new-dialog.component.html',
  styleUrls: ['./whats-new-dialog.component.scss']
})
export class WhatsNewDialogComponent extends LocalizableComponent {
  @Output() closeEvent: EventEmitter<void> = new EventEmitter<void>();
  currentModalIndex = 0;
  isTransitioning = false;
  isClosing = false;

  get whatsNewItems() {
    return this.whatsNew.whatsNewItems;
  }

  get currentItem() {
    return this.whatsNewItems[this.currentModalIndex];
  }

  get helocFaqsUrl(): string {
    return environment.helpfulLinks.consumer.helocFaqs;
  }

  get quickQuoteUrl(): string {
    return '/quick-quote';
  }

  isHelocItem(item: any): boolean {
    return item.title.includes('heloc-2-0');
  }

  isNewLowerStartingRatesItem(item: any): boolean {
    return item.title.includes('new-lower-starting-rates');
  }

  constructor(@Inject(L10N_LOCALE) locale: L10nLocale, private readonly whatsNew: WhatsNewService) {
    super(locale);
  }

  showNextPage() {
    if (this.currentModalIndex < this.whatsNewItems.length - 1 && !this.isTransitioning) {
      this.smoothTransition(() => {
        this.currentModalIndex++;
      });
    }
  }

  showPreviousPage() {
    if (this.currentModalIndex > 0 && !this.isTransitioning) {
      this.smoothTransition(() => {
        this.currentModalIndex--;
      });
    }
  }

  private smoothTransition(callback: () => void) {
    this.isTransitioning = true;

    // Fade out current content
    setTimeout(() => {
      callback();

      // Fade in new content
      setTimeout(() => {
        this.isTransitioning = false;
      }, 50);
    }, 150);
  }

  close() {
    if (!this.isClosing) {
      this.isClosing = true;

      // Smooth fade out animation before closing
      setTimeout(() => {
        this.currentModalIndex = 0; // Reset to the first modal when closing
        this.closeEvent.emit();
      }, 200); // Match the CSS animation duration
    }
  }
}
